import {CartItemType} from './cart-item-type.model';
export abstract class CartItem {
  itemType: CartItemType;
  creationTime: number;
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/model/shopping-cart/cart-item.model.ts